import { render } from "./InfoSnackbar.vue?vue&type=template&id=22ea42c5&scoped=true&ts=true"
import script from "./InfoSnackbar.vue?vue&type=script&lang=ts"
export * from "./InfoSnackbar.vue?vue&type=script&lang=ts"

import "./InfoSnackbar.vue?vue&type=style&index=0&id=22ea42c5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ea42c5"]])

export default __exports__